export default __webpack_public_path__ + "static/media/Partially Oriented Yarn.07ec3fd1.jpg";